import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
  ValueSansProvider,
} from '@angular/core';
import { AppMessages } from './message';

export const APP_MESSAGES = new InjectionToken('APP_MESSAGES', {
  providedIn: 'root',
  factory: () => ({}),
});

export interface AppMessagesUseValue extends ValueSansProvider {
  useValue: AppMessages;
}

export interface AppMessagesUseClass extends ClassSansProvider {
  useClass: Type<AppMessages>;
}

export interface AppMessagesUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => AppMessages;
}

export type AppRoutesProvider =
  | AppMessagesUseValue
  | AppMessagesUseFactory
  | AppMessagesUseClass;

export type AppMessagesConfig = {
  paths?: AppMessagesUseValue;
};

export function provideAppMessages(config: AppMessagesConfig) {
  return [
    {
      provide: APP_MESSAGES,
      multi: true,
      ...config.paths,
    },
  ];
}
